/**
 * Session-expired event system for datasurfr.
 *
 * Dispatch a session-expired event to show the SignIn modal instead of
 * hard-redirecting to "/". The SessionGuard component listens for this
 * event and renders the modal overlay.
 */

export const SESSION_EXPIRED_EVENT = "session-expired" as const;

export type SessionExpiredReason = "expired" | "logout";

export type SessionExpiredDetail = {
  /** "expired" = silent refresh failed; "logout" = explicit user/cross-app logout */
  reason: SessionExpiredReason;
};

/**
 * Dispatch the session-expired custom event on the window.
 * SessionGuard listens for this and shows the modal.
 */
export const emitSessionExpired = (
  reason: SessionExpiredReason = "expired"
): void => {
  if (typeof window === "undefined") return;
  console.warn("[AUTH][datasurfr][sessionEvents.ts] Emitting session-expired | reason:", reason);
  window.dispatchEvent(
    new CustomEvent<SessionExpiredDetail>(SESSION_EXPIRED_EVENT, {
      detail: { reason },
    })
  );
};
